import React from 'react';
import styled from '@emotion/styled';

export const ORDERS_TABLE_CLASS_NAME = 'orders-table';
export const HIGHLIGHTED_CLASS_NAME = 'highlighted';

export default () => {
  return (
    <StyledContainer className={ORDERS_TABLE_CLASS_NAME}>
      <thead>
        <tr>
          <th>Order</th>
          <th className="wideTh">Status</th>
          <th>Time</th>
          <th>Date</th>
          <th>Start</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>
        <tr><td colSpan={6}>Loading...</td></tr>
      </tbody>
    </StyledContainer >
  );
};

export const StyledContainer = styled.table`
  text-align: left;
  font-family: Helvetica, sans-serif;
  font-size: 16px;
  border-collapse: collapse;
  cursor: pointer;

  th,
  td {
    padding: 0.75em 0 0.75em 50px;
    white-space: nowrap;

    &:last-child {
      padding-right: 35px;
    }
  }

  th {
    text-transform: uppercase;
    font-weight: bold;
  }

  .wideTh {
    width: 100%;
  }

  td {
    border-top: 1px solid rgba(110, 117, 124, 0.2);
    color: #6e757c;
  }

  tbody {
    tr {
      transition: background 0.2s linear;

      &:hover,
      &.${HIGHLIGHTED_CLASS_NAME} {
        background: #ffd;
      }
    }
  }

  .id {
    color: #325882;
    font-weight: bold;
  }
`;
